import React, { useEffect } from 'react';
import BetradarStatisticsTabs from '../utils';
import { useReframe } from 'nike-re-framejs';
import { TabButton } from '../../turboLive/components/Tabs';
import { hasMbm$, isMbmLoaded$$ } from '../../turboLive/push/detail/subs';
import { isLiveEvent$$ } from '../subs';
import i18n from '../../../common/i18n';
import Dummy from '../../Dummy/Dummy';
import { useMbmPush } from '../../turboLive/push/detail/hooks';
import { useMbmForMatch } from '../hooks/useMbmForMatch';
import { isFunction } from 'lodash';

function MatchStatisticsTabs({ sportId, active, scrollElementRef, onTabClick, infocentrumTabs, eventId, callback }) {
    const sportsWithLastMatchesTabName = [7, 61, 85, 88, 89, 101];
    const { subscribe } = useReframe();
    const hasMbm = subscribe(hasMbm$(eventId));
    const isMbmLoaded = subscribe(isMbmLoaded$$);
    const isLiveEvent = subscribe(isLiveEvent$$);
    useMbmPush(eventId, isLiveEvent);
    const { isLoading } = useMbmForMatch(eventId, !isLiveEvent);
    const isDummy = (isLoading && !isLiveEvent) || (!isMbmLoaded && isLiveEvent);
    useEffect(() => {
        if (!isDummy && infocentrumTabs?.size && isFunction(callback)) {
            callback();
        }
    }, [callback, isDummy, hasMbm, infocentrumTabs]);

    //za toto pojdem do pekla ale nenasiel som inu moznost... ako vriesit tento problem na portaly :/
    if (!infocentrumTabs && !isLiveEvent && !hasMbm) {
        return null;
    }

    return (
        <>
            {isDummy ? (
                <Dummy otherClass={'flex-1'} />
            ) : (
                <>
                    {hasMbm ? (
                        <TabButton
                            label={i18n('nui.matchStatistics.tabs.mbm')}
                            name={BetradarStatisticsTabs.MBM}
                            active={active}
                            onTabChange={onTabClick}
                            scrollRef={scrollElementRef}
                            key={BetradarStatisticsTabs.MBM}
                            data-atid={'betradar-mt-tab'}
                        />
                    ) : null}
                    {infocentrumTabs?.size
                        ? infocentrumTabs?.map(tabName => {
                              const tabNameTranslated = BetradarStatisticsTabs[tabName];
                              return (
                                  <TabButton
                                      label={
                                          sportsWithLastMatchesTabName.includes(sportId) &&
                                          tabNameTranslated === 'standings'
                                              ? i18n('nui.matchStatistics.tabs.lastMatches')
                                              : i18n(`nui.matchStatistics.tabs.${tabNameTranslated}`)
                                      }
                                      trackData={{ category: 'Ponuka', action: tabName, label: 'Detail zapasu' }}
                                      name={tabNameTranslated}
                                      active={active}
                                      onTabChange={onTabClick}
                                      scrollRef={scrollElementRef}
                                      key={tabNameTranslated}
                                      data-atid={'betradar-mt-tab'}
                                  />
                              );
                          })
                        : null}
                </>
            )}
        </>
    );
}

export default MatchStatisticsTabs;
